import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import UserArticleTabs from './UserArticleTabs'
import { DestinationSelector } from '../../common/formParts/FieldPartsStyled'

const getUserArticlesForArticle = (articleName, setUsers) => {
  // get from API the users for the selected article
  return fetch(`/manage/users_by_article_for_news?article_name=${articleName}`)
  .then(res => res.json())
    .then(body => {
      if ('users' in body) {
        return body
      } else {
        return Promise.reject()
      }
    })
    .then(body => {
      if (body.users.length !== 0) {
        return body.users
      } else {
        return []
      }
    })
    .then(users => {
      const usersFromSearch = users.map((user) => {
        return {
          name: user.name,
          id: user.id,
          room: user.room,
          user_article_id: user.user_article_id
        }
      })
      return setUsers(usersFromSearch)
    })
    .catch(err => {
      console.error(err)
    })
}

const DeliveryDestinationSelector = (props) => {
  const selectOptions = props.options
  const [users, setUsers] = useState([])
  const [alert, setAlert] = useState('')
  const [updateAlert, setUpdateAlert] = useState(0) // used to force the update of the alert message

  useEffect(() => {
    const submitButton = document.getElementById('news-submit-button')
    const warningMessages = document.querySelectorAll(".warningMessage")
    const warningMessagesArray = Array.from(warningMessages)
    const warningMessagesCount = warningMessagesArray.filter((warningMessage) => {
      return warningMessage.innerText !== ""
    }).length
    if (warningMessagesCount > 0) {
      submitButton.disabled = true
    } else {
      submitButton.disabled = false
    }
  }, [updateAlert])

  const selectedSource = props.delivery_destination.name
  // Edit mode :
  let initSelected = null
  if (props.delivery_destination.id) {
    initSelected = { label: props.delivery_destination.destination_name, value: props.delivery_destination.id }
  }
  const [selected, setSelected] = useState(initSelected || null)
  const [selectedMembers, setSelectedMembers] = useState(props.delivery_destination.selected_members || [])
  if (selectedSource === "member_dwelling_unit" &&
    props.delivery_destination.id && users.length === 0 &&
    props.delivery_destination.destination_name !== undefined
  ) {
    getUserArticlesForArticle(props.delivery_destination.destination_name, setUsers)
  }
  // end edit Mode

  const clearWarningMessages = () => {
    // empty all the div with class warningMessage
    const warningMessages = document.querySelectorAll(".warningMessage")
    warningMessages.forEach((warningMessage) => {
      warningMessage.innerText = ""
    })
  }

  const checkIsInPreviousSelection = (currentSelection, previousSelectionNames) => {
    // Remove empty strings from previousSelectionNames
    previousSelectionNames = previousSelectionNames.filter((name) => name !== "")

    // Check if currentSelection is in any of the previousSelectionNames
    if (previousSelectionNames.includes(currentSelection)) {
      setAlert("この配信先は既に選択されています。")
      setUpdateAlert(updateAlert + 1)
      return
    }

    const appsAndGroups = [...props.apps_articles, ...props.news_segment_articles]

    // Check if the currentSelection (article) is related to any selectionName
    for (const selectionName of previousSelectionNames) {
      for (const appOrGroup of appsAndGroups) {
        if (appOrGroup[selectionName] !== undefined) {
          const articlesForThisKey = appOrGroup[selectionName]
          const found = articlesForThisKey.some(
            (article) => article.article_name === currentSelection
          )
          if (found) {
            // console.log("is related to: ", selectionName)
            setAlert("既に選択されている配信先と会員住戸の重複があります。")
            setUpdateAlert(updateAlert + 1)
            return
          }
        }
      }
    }
  }

  const checkDoesSelectionContainsSelection = (destName, inputValues) => {
    const appsAndGroups = [...props.apps_articles, ...props.news_segment_articles]
    let articles = []

    appsAndGroups.forEach((appOrGroup) => {
      const articlesForThisKey = appOrGroup[destName]
      if (articlesForThisKey !== undefined) {
        articles.push(...articlesForThisKey)
        const articleNames = articles.map((article) => article.article_name)
        // Find the intersection between inputValues and articleNames
        const intersection = inputValues.filter((value) => articleNames.includes(value))

        if (intersection.length > 0) {
          // console.log("contains ", intersection.join(", "))
          setAlert("既に選択されている配信先と会員住戸の重複があります。")
          setUpdateAlert(updateAlert + 1)
          return
        }
      }
    })
  }

  const onChangeSelect = (e) => {
    if (e !== null && e.label !== undefined && e.label !== "") {
      // check that the e.label is not already a label in a select input on the page
      const inputs = document.querySelectorAll("div[name^=selector\\[")
      const inputsArray = Array.from(inputs)
      const inputValues = inputsArray.map((input) => {
        return input.getAttribute('data-destination-name')
      })
      clearWarningMessages()
      setAlert("")
      setUpdateAlert(updateAlert + 1)
      // check that no app or group containing the selected article is already selected
      checkIsInPreviousSelection(e.label, inputValues)
      // check that the selection (e.label) is not already a related to select input on the page
      checkDoesSelectionContainsSelection(e.label, inputValues)
      // if the selected source is member_dwelling_unit, we need to get the users for the selected article
      if (selectedSource === "member_dwelling_unit") {
        getUserArticlesForArticle(e.label, setUsers)
        setSelectedMembers([])
      }
      setSelected({ label: e.label, value: e.value })
    } else {
      setSelected(null)
    }
  }

  const firstRender = useRef(true)

  useEffect(() => {
    // we dont want to reset the selected value on first render (case of edit mode)
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    setSelected(null)
  }, [props.delivery_destination.name])

  return (
    <DestinationSelector
      key={"selector-" + props.delivery_destination.number}
      name={"selector[" + selectedSource + "_id]"}
      data-destination-name={selected ? selected.label : ''}
      data-destination-type={selectedSource || ''}>
      {selectOptions && selectOptions.length > 0 &&
        <div>
          <Select
            key={"select-" + props.delivery_destination.id}
            value={selected || ''}
            className="selectDestination"
            placeholder={'ここから選択'}
            options={selectOptions.map((option, index) => ({
              label: option[0],
              value: option[1],
              key: index,
            }))}

            onChange={(e) => {
              onChangeSelect(e)
            }}
            name={"news[" + selectedSource + "_id][][id]"}
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          // isClearable={true}
          // isSearchable={true}
          />
           {/* a hidden input for the postion of the current destination made from number */}
          <input type="hidden" name={"news[" + selectedSource + "_id][][display_order_num]"} value={props.delivery_destination.number} />
          {alert && <div key={updateAlert} className='warningMessage'>{alert}</div>}
        </div>
      }
      {
        selectedSource === "member_dwelling_unit" && users.length > 0 && (
          <UserArticleTabs users={users} indexId={props.delivery_destination.id} selected={selected} selectedMembers={selectedMembers}></UserArticleTabs>
        )
      }
    </DestinationSelector>
  )
}

export default DeliveryDestinationSelector
